import React from 'react';
import { Link } from 'react-router-dom';
import { FaAngleDown } from "react-icons/fa";
import { useSelector } from 'react-redux';
// menu is an object like follows
// [
//     {
//         "id": 1,
//         "url": "/legal",
//         "page": {
//             "id": 1,
//             "slug": "legal",
//             "image": "guacara/blog/post/2025/08/21/cerro_cruz.webp",
//             "title": "Legal",
//             "enabled": true,
//             "promoted": false,
//             "parent_id": null
//         },
//         "label": "Legal",
//         "props": null,
//         "enabled": true,
//         "page_id": 1,
//         "parent_id": null
//     },
//     {
//         "id": 2,
//         "url": null,
//         "page": null,
//         "label": "Municipio",
//         "props": null,
//         "enabled": true,
//         "page_id": null,
//         "parent_id": null,
//         "children": [
//             {
//                 "id": 3,
//                 "url": "/historia",
//                 "page": {
//                     "id": 2,
//                     "slug": "historia",
//                     "image": "guacara/blog/post/2025/08/21/piedra_casimbas.webp",
//                     "title": "Historia",
//                     "enabled": true,
//                     "promoted": false,
//                     "parent_id": null
//                 },
//                 "label": "Historia",
//                 "props": null,
//                 "enabled": true,
//                 "page_id": 2,
//                 "parent_id": 2
//             },
//             {
//                 "id": 4,
//                 "url": "/alcalde",
//                 "page": {
//                     "id": 3,
//                     "slug": "alcalde",
//                     "image": "guacara/blog/post/2025/08/21/alcaldesa_lesbia_castillo.webp",
//                     "title": "Alcalde",
//                     "enabled": true,
//                     "promoted": false,
//                     "parent_id": null
//                 },
//                 "label": "Alcalde",
//                 "props": null,
//                 "enabled": true,
//                 "page_id": 3,
//                 "parent_id": 2
//             }
//         ]
//     }
// ]

const Nav = () => {
    const {menu} = useSelector(state => state.blog);
    return (
        <nav className="mainmenu-nav">
            <ul className="mainmenu">
                {menu && menu.length > 0 && menu.map((item, index) => (
                    <li key={index} className={item.children ? "menu-item-has-children" : ""}>
                        <Link to={item.url}>{item.label}
                        {item.children && <FaAngleDown />}
                        </Link>
                        {item.children && (
                            <ul className="gc-submenu">
                                {item.children.map((child, childIndex) => (
                                    <li key={childIndex}><Link to={child.url.startsWith("/") ? `/page${child.url}?id=${child.page_id}` : child.url}>{child.label}</Link></li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
                {/* <li className="menu-item-has-children">
                    <Link to="#">Digital Agency <FaAngleDown /> </Link>
                    <ul className="gc-submenu">
                        <li><Link to={process.env.PUBLIC_URL + "/digital-agency"}>Digital Agency</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/creative-agency"}>Creative Agency</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/personal-portfolio"}>Personal Portfolio</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/home-startup"}>Home Startup</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/corporate-agency"}>Corporate Agency</Link></li>
                        <li><a href="https://new.gestionciudad.com/demo/react/abstrak-rtl/">RTL Demo</a></li>
                    </ul>
                </li>
                <li className="menu-item-has-children">
                    <Link to="#">Services <FaAngleDown /></Link>
                    <ul className="gc-submenu">
                        <li><Link to={process.env.PUBLIC_URL + "/service-one"}>Service</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/service-two"}>Service Two</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/service-details/design"}>Service Details</Link></li>
                    </ul>
                </li>
                <li className="menu-item-has-children">
                    <Link to="#">Portfolio <FaAngleDown /></Link>
                    <ul className="gc-submenu">
                        <li><Link to={process.env.PUBLIC_URL + "/project-grid-one"}>Two Column</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/project-grid-two"}>Three Column</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/project-grid-three"}>Four Column</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/project-width-one"}>Three Column Width</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/project-width-two"}>Four Column Width</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/project-details/plan-management"}>Portfolio Details</Link></li>
                    </ul>
                </li>
                <li className="menu-item-has-children">
                    <Link to="#">Pages <FaAngleDown /></Link>
                    <ul className="gc-submenu">
                        <li><Link to={process.env.PUBLIC_URL + "/about-us"}>About Us</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/our-office"}>Our Office</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/case-study"}>Case Study</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/case-details/whitehorse"}>Case Study Details</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/team"}>Team</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/team-details/jane-cooper"}>Team Details</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/our-clients"}>Our Clients</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/testimonials"}>Testimonial</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/pricing-table"}>Pricing Table</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/typography"}>Typography</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/404"}>404 Page</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/coming-soon"}>Coming Soon</Link></li>
                    </ul>
                </li>
                <li className="menu-item-has-children">
                    <Link to="#">Blog <FaAngleDown /></Link>
                    <ul className="gc-submenu">
                        <li><Link to={process.env.PUBLIC_URL + "/blog-grid"}>Blog</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/blog-details/1"}>Standard Post</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/blog-details/2"}>Gallery Post</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/blog-details/3"}>Video Post</Link></li>
                      
                    </ul>
                </li> */}
                <li><Link to={process.env.PUBLIC_URL + "/contact"}>Contacto</Link></li>
            </ul>
        </nav>
    )
}

export default Nav;